
import styles from './PromotionBoard.module.scss';
import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TableList } from "../../../components";
import common from '../../../common';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function PromotionBoard({ cateIdx, type }) {

    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const pageid = queryParams.get('pageid');

    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState([]);
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    
    const [headCategories, setHeadCategories] = useState([]);

    const tableLoadData = {
        tableType: 'PromotionBoard',
        type: type,
        cate: [cateIdx]
    };

    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_table`, tableLoadData , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setData(data);

                const headCategories = await fetchCateHeadData(); 
                filterDataByCategory(data, headCategories)
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }

    const headCateForm = {document_category_idx : 3}

    const fetchCateHeadData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_document_category_head_table`, headCateForm , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setHeadCategories(data);
                return data;
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }

    const filterDataByCategory = (data, headCategories) => {
        headCategories.forEach(category => {
            const filteredData = data.filter(item => item.headCate === category.name);
            if (category.idx === 5) {
                setData1(filteredData);
            } else if (category.idx === 6) {
                setData2(filteredData);
            } else if (category.idx === 7) {
                setData3(filteredData);
            }
        });
    }


    useEffect(() => {
        fetchData();
    }, []);


    const columns = useMemo(() => [
        { title: '제목', dataIndex: 'title', className: ' text_start' },
        { title: '등록일', dataIndex: 'createTime', className: '' },
        { title: '작성자', dataIndex: 'member', className: '' },
        { title: '추천수', dataIndex: 'likeCount', className: '' },
    ], []);

    const pageSize = 10;
    const categoryOptions = useMemo(() => [
        { label: '전체', value: '전체' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'contents' },
        { label: '작성자', value: 'member' },
    ], []);

    const [returnTableList, setReturnTableList] = useState(null);

    useEffect(() => {
        let selectedData = [];
        switch (pageid) {
            case 'all':
                selectedData = data;
                break;
            case '5':
                selectedData = data1;
                break;
            case '6':
                selectedData = data2;
                break;
            case '7':
                selectedData = data3;
                break;
            default:
                selectedData = data;
        }

        setReturnTableList(
            <TableList key={pageid} data={selectedData} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type="Editor" />
        );


    }, [pageid, data, data1, data2, data3, pageSize, categoryOptions]);

    const [activeTab, setActiveTab] = useState('all');

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        navigate(`?pageid=${tabIndex}`);
    };

    const handleRowClick = () => {
        window.location.href = `/board?cateIdx=`+cateIdx+`&boardType=new`;
    };

    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>홍보게시판</span>
                <div className={styles.tab_box}>
                    <button
                        className={`${styles.tab_btn} ${activeTab === 'all' ? styles.active : ''}`}
                        onClick={() => handleTabClick('all')}
                    >
                        전체
                    </button>
                    {headCategories.map(category => (
                        <button
                            key={category.idx} 
                            className={`${styles.tab_btn} ${activeTab === category.idx ? styles.active : ''}`}
                            onClick={() => handleTabClick(category.idx)}
                        >
                            {category.name}  
                        </button>
                    ))}
                </div>
                {returnTableList}
                <div className="editor_regist_btn_box">
                    <button 
                        className='editor_regist_btn'
                        onClick={handleRowClick}    
                    >글쓰기</button>
                </div>
            </div>
        </>
    );
}

export default PromotionBoard;